import React from 'react';
import PropTypes from 'prop-types';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { RadioButtonGroup, RadioButton } from 'material-ui/RadioButton';
import { GENDERS } from '../../utils/constants';

export default function genderSelector({ input, t, ...rest }) {
  return (
    <MuiThemeProvider>
      <RadioButtonGroup
        {...input}
        {...rest}
        valueSelected={input.value}
        onChange={(event, value) => input.onChange(value)}
        style={{ display: 'flex', width: '100%' }}
      >
        <RadioButton
          iconStyle={{ fill: '#646777' }}
          labelStyle={{ color: '#646777' }}
          value={GENDERS.OTHER}
          label={t(`general.gender-${GENDERS.OTHER}`)}
        />
        <RadioButton
          iconStyle={{ fill: '#646777' }}
          labelStyle={{ color: '#646777' }}
          value={GENDERS.MALE}
          label={t(`general.gender-${GENDERS.MALE}`)}
        />
        <RadioButton
          iconStyle={{ fill: '#646777' }}
          labelStyle={{ color: '#646777' }}
          value={GENDERS.FEMALE}
          label={t(`general.gender-${GENDERS.FEMALE}`)}
        />
      </RadioButtonGroup>
    </MuiThemeProvider>
  );
}

genderSelector.propTypes = {
  input: PropTypes.shape().isRequired,
  t: PropTypes.func.isRequired,
};
